import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-92b4e0c0")

_pushScopeId("data-v-92b4e0c0")
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "Security Information", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", null, "Password Change", -1)
const _hoisted_4 = { class: "buttons-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Save")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef",
        "status-icon": "",
        "label-width": "200px"
      }, {
        default: _withId(() => [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_el_form_item, {
            label: "New Password",
            prop: "password",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.password = $event)),
                type: "password",
                "auto-complete": "off",
                disabled: !_ctx.canEdit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Confirm New Password",
            prop: "password_confirm",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.password_confirm,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.password_confirm = $event)),
                type: "password",
                "auto-complete": "off",
                disabled: !_ctx.canEdit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _withDirectives(_createVNode(_component_el_button, {
                  onClick: _ctx.saveUser,
                  type: "primary",
                  disabled: !_ctx.canEdit
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]), [
                  [_directive_loading, _ctx.saveState === _ctx.FetchStates.FETCHING]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
})